import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';

import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { Utils } from '@src/utils/util';
import { HooksComponent } from './hooks.component'
import { HooksDataComponent } from './hooks-data/hooks-data.component'; 
import {HttpClientModule} from '@angular/common/http';
import { DbmAdditionalOptionsModule } from '@app/shared/components/dbm-components/dbm-additional-options/dbm-additional-options.module';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule, MatDatepickerModule, MatInputModule, MatNativeDateModule , HttpClientModule , DbmAdditionalOptionsModule ],
    declarations: [HooksComponent,HooksDataComponent],
    entryComponents: [HooksComponent],
    exports: [HooksComponent],
    providers: [MatDatepickerModule, MatNativeDateModule, Utils]
})
export class HooksModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/hooks-ang7/hooks.component.module.ts